import { useLocalStorageState, useScroll } from 'ahooks';
import React, { useEffect, useRef, useState } from 'react'
import CommunityList from '../game/detail/Community/comments/CommunityList.js'
import { RightOutlined } from '@ant-design/icons';
import { NavLink } from '../../lib/Navigation.js';
import CommunityGames from './CommunityGames';
import PublishAlert from './PublishAlert.js';
import { Popover, PageIndicator } from 'antd-mobile';
import URI from 'urijs';
import useActiveState from '../../lib/useActiveState.js';
import '../game/detail/Community/css/Community.css'
import AuthAlert from '../components/AuthAlert.js';
import general from '../../general.js';
import UnreadBadge from './UnreadBadge.js';
import { Swiper, SwiperSlide } from 'swiper/react';

let scrollTop = 0
export default function NewCommunityItem(props) {

  const router = [
    {
      id: 'all',
      component: CommunityList,
      name: '全部',
      tagid: '-1'
    },
    {
      id: 'comment',
      component: CommunityList,
      name: '评论',
      tagid: '1',
      src: 'resources/251009/comment.png'
    },
    {
      id: 'index',
      component: CommunityList,
      name: '攻略',
      tagid: '2',
      src: 'resources/251009/strategy.png'
    },
    {
      id: 'question',
      component: CommunityList,
      name: '问答',
      tagid: '3',
      src: 'resources/251009/question.png'
    },
  ]

  const { own, hot, activeItem, active, prefix, isMainCommunity } = props;

  const [init, setInit] = useState(false)
  const [idx, setIdx] = useState(-1)
  const [search_info] = useState('')
  const [alert, setAlert] = useState(false)
  const [sort, setSort] = useState({ text: '最新帖子', key: 'new_time' })
  const [close, setClose] = useState(true)
  const [visible, setVisible] = useState(false)
  const [agent] = useActiveState('agent');
  const actions = activeItem?.exclusive_benefit || []
  const activity_list = activeItem?.activity_list || []
  const [activitys, setActivitys] = useState([])
  const [user, setUser] = useActiveState('user')
  const [isCheckAuth, setIsCheckAuth] = useState(false); //实名认证弹框状态
  const [cachePublish_from_game, setCachePublish_from_game] = useLocalStorageState('publish_from_game', {})
  const ref = useRef()
  const scrollRef = useRef()
  const itemRefs = useRef(new Map());
  const [current, setCurrent] = useState(0);

  const updateActivityList = () => {
    if (activity_list.length > 0) {
      if (activity_list.length > 3) {
        setActivitys(activity_list.slice(0, 3))
      } else {
        setActivitys(activity_list)
      }
    }
  }

  useEffect(() => {
    setClose(true)
    updateActivityList()
  }, [activeItem?.game_name])

  useEffect(() => {
    if (active && idx === -1) {
      setIdx(0)
    }
  }, [active])

  useEffect(() => {
    if (!init) {
      updateActivityList()
    }
  }, [init])

  const handleInit = () => {
    setInit(true)
  }

  const scroll = useScroll(document.getElementsByClassName(`${prefix}community-item-content`)[0])
  useEffect(() => {
    if (active) {
      scrollTop = scroll.top
      if (props.onScroll) {
        props.onScroll(scroll)
      }
    }
  }, [active, scroll])

  const sorts = [
    { key: 'new_time', text: '最新帖子' },
    { key: 'hottest', text: '最热帖子' },
    { key: 'new_reply', text: '最新回复' },
  ]

  const handleRouter = (action) => {
    if (action.type == 'platformsign') {
      return '/task/signdata'
    } else if (action.type == 'sign_gift') {
      return '/gamesign?id=' + action?.maiyou_gameid
    } else if (action.type == '648bouns') {
      return '/giftproject'
    } else if (action.type == 'card') {
      return '/save/newcard'
    } else if (action.type == 'vip') {
      return '/save/newvip'
    } else if (action.type == 'try_play') {
      return '/task/tryplay'
    } else if (action.type == 'honor_vip') {
      return '/growthlevel'
    } else if (action.type == 'game_info') {
      return '/game?id=' + action?.genre_value
    } else if (action.type == 'customer_service') {
      return '/service'
    } else if (action.type == 'post_info') {
      return '/communityDetail?id=' + action.genre_value + '&tagid=' + action.tagid + '&circles_type=' + action.circles_type + '&topic_id=' + action.maiyou_gameid
    } else if (action.type == 'newsinfo_activity') {
      return 'article/detail?id=' + action?.genre_value + '&type=activity'
    } else if (action.type == 'newsinfo_strategy') {
      return 'article/detail?id=' + action?.genre_value + '&type=raiders'
    } else if (action.type == 'newsinfo_activity_list') {
      return '/game/article?id=' + action?.genre_value
    } else if (action.type == 'newsinfo_strategy_list') {
      return '/game/article?id=' + action?.genre_value + '&type=1'
    } else {
      return ''
    }
  }

  const actionsDivs = (action, type) => {
    if (action.type == 'ptb') {
      return (
        type == 'action' ?
          <NavLink
            key={action.id}
            className="item"
            to={(() => {
              let url = URI("https://sys.wakaifu.com/home/MixPay/ptb")
                .addQuery('username', localStorage.getItem('username'))
                .addQuery('token', localStorage.getItem('token'))
                .addQuery('location_url', window.location.origin)
                .addQuery('agent', agent)
                .addQuery('from', 'react')
                .toString();
              return url;
            })()}
            iframe={{ title: '平台币充值', sinfo: 'nisptb' }}
            user={true}>
            <img className='icon' src={action.icon} alt="" />
            <div className='text'>{action.title}</div>
          </NavLink> :
          <div
            key={action.news_id}
            className='activity-item'>
            <NavLink to={(() => {
              let url = URI("https://sys.wakaifu.com/home/MixPay/ptb")
                .addQuery('username', localStorage.getItem('username'))
                .addQuery('token', localStorage.getItem('token'))
                .addQuery('location_url', window.location.origin)
                .addQuery('agent', agent)
                .addQuery('from', 'react')
                .toString();
              return url;
            })()}
              iframe={{ title: '平台币充值', sinfo: 'nisptb' }}
              user={true}
              className='activity-info'>
              <div className={"activity-tag style" + action.color_style}>{action.tips}</div>
              <div className='activity-title'>{action.title}</div>
              <RightOutlined style={{ color: '#999999', fontSize: 10 }} />
            </NavLink>
          </div>
      )
    } else if (action.type == 'friend_help' ||
      action.type == 'community_recruit' ||
      action.type == 'platformactive' ||
      action.type == 'game_benefit' ||
      action.type == 'gold_coin_challenge') {
      return (
        type == 'action' ?
          <NavLink
            to={(() => {
              let url = URI(action.genre_value)
                .addQuery('topic_id', action.maiyou_gameid)
                .addQuery('username', localStorage.getItem('username'))
                .addQuery('token', localStorage.getItem('token'))
                .addQuery('location_url', window.location.origin)
                .addQuery('agent', agent)
                .addQuery('from', 'react')
                .toString();
              return url;
            })()}
            key={action.id}
            className="item"
            iframe={{ title: action.web_title }}
            user={action.needlogin}>
            <img className='icon' src={action.icon} alt="" />
            <div className='text'>{action.title}</div>
          </NavLink> :
          <div key={action.news_id} className='activity-item'>
            <NavLink
              to={(() => {
                let url = URI(action.genre_value)
                  .addQuery('username', localStorage.getItem('username'))
                  .addQuery('token', localStorage.getItem('token'))
                  .addQuery('location_url', window.location.origin)
                  .addQuery('agent', agent)
                  .addQuery('from', 'react')
                  .toString();
                return url;
              })()}
              key={action.id}
              iframe={{ title: action.web_title }}
              user={action.needlogin}
              className='activity-info'>
              <div className={"activity-tag style" + action.color_style}>{action.tips}</div>
              <div className='activity-title'>{action.title}</div>
              <RightOutlined style={{ color: '#999999', fontSize: 10 }} />
            </NavLink>
          </div>
      )
    } else if (action.type == 'enterprise_wechat' || action.type == 'browser') {
      return type == 'action' ?
        <NavLink
          key={action.id}
          className="item"
          user={action.needlogin}
          onClick={() => {
            window.open(action.genre_value, 'target', '')
          }}>
          <img className='icon' src={action.icon} alt="" />
          <div className='text'>{action.title}</div>
        </NavLink> :
        <div
          onClick={() => {
            window.open(action.genre_value, 'target', '')
          }}
          key={action.news_id}
          user={action.needlogin}
          className='activity-item'>
          <NavLink to={() => handleRouter(action)} className='activity-info'>
            <div className={"activity-tag style" + action.color_style}>{action.tips}</div>
            <div className='activity-title'>{action.title}</div>
            <RightOutlined style={{ color: '#999999', fontSize: 10 }} />
          </NavLink>
        </div>
    }
    else {
      return (
        type == 'action' ? actionDiv(action) : activityDiv(action)
      )
    }
  }

  const actionDiv = (action) => {
    return <NavLink
      user={action.needlogin}
      to={() => handleRouter(action)}
      key={action.id}
      className="item">
      <img className='icon' src={action.icon} alt="" />
      <div className='text'>{action.title}</div>
    </NavLink>
  }

  const activityDiv = (item) => {
    return <div key={item.news_id} className='activity-item'>
      <NavLink user={item.needlogin} to={() => handleRouter(item)} className='activity-info'>
        <div className={"activity-tag style" + item.color_style}>{item.tips}</div>
        <div className='activity-title'>{item.title}</div>
        <RightOutlined style={{ color: '#999999', fontSize: 10 }} />
      </NavLink>
    </div>
  }

  const handleJoinIM = () => {
    if (user.isCheckAuth && !user.isRealNameAuth) {
      setIsCheckAuth(true)
      return
    }
    general.axios.post('/base/yunxin/joinTeams', { topic_id: activeItem?.maiyou_gameid })
      .then(res => {
        const { data, status } = res.data
        if (status.succeed) {
          const { tid } = data.info
          general.history.push(`/chat?tid=${tid}`)
          // if (localStorage.getItem('yx_login')){
          //   general.history.push(`/chat?tid=${tid}`)
          // }else{
          //   PubSub.publish('loginSubscribe',true)
          //   setTimeout(()=>{
          //     general.history.push(`/chat?tid=${tid}`)
          //   },2000)
          // }
        } else {
          Dialog.error(status.error_desc)
        }
      })
  }

  const imDiv = (className) => {
    return (
      <div className={className}>
        <NavLink user={false} to={'/community/search?circles_type=' + activeItem?.circles_type + '&topic_id=' + (activeItem?.maiyou_gameid || '')} style={{ display: 'flex', alignItems: 'center' }}>
          <img src="resources/251009/search.png" alt="" height={17} />
        </NavLink>
        {activeItem?.circles_type == 'game' && <NavLink className="join" to={'/game?id=' + activeItem?.game_id}>
          <div className='btn'>下载游戏</div>
          <img className='right' src="resources/251009/right.png" alt="" />
        </NavLink>}
        {/* {activeItem?.is_open_cluster && <NavLink className="join" onClick={handleJoinIM}>
          <div className='btn'>{activeItem?.is_join_cluster ? '进入群聊' : '加入群聊'}</div>
          <img className='right' src="resources/251009/right.png" alt="" />
        </NavLink>}
        {activeItem?.is_open_cluster && activeItem?.is_join_cluster && <div className='unread-num'><UnreadBadge active={active} tid={activeItem?.tid}></UnreadBadge></div>} */}
      </div>
    )
  }

  const handleHotGameClick = (item, index) => {
    if (index >= hot.length - 3) {
      return
    }
    // 获取被点击的子元素的 DOM 节点
    const itemElement = itemRefs.current.get(item.maiyou_gameid);

    if (itemElement) {
      // 使用 scrollIntoView() 方法
      itemElement.scrollIntoView({
        behavior: 'smooth', // 平滑滚动
        block: 'nearest',   // 垂直方向上保持最近的边缘对齐（通常不重要，因为是横向滚动）
        inline: 'center',   // **核心：将元素水平滚动到容器的中心**
      });
    }
  }

  return (
    <div className='community-item-page-index'>
      <div className="community-item-header-bg">
        <img className='icon' src={activeItem?.bgicon} alt="" />
        <div className="community-item-header-bg-overlay" style={{ background: `linear-gradient(${activeItem?.bgcolor_trans} 0%, ${activeItem?.bgcolor} 70%, ${activeItem?.bgcolor} 70%, ${activeItem?.bgcolor} 100%)` }}></div>
      </div>

      {isMainCommunity && <div className='community-header flex' style={{ opacity: scrollTop > 150 ? 0 : 1, }}>
        <div className='community-header-container' ref={ref}>
          <div className='own-discussion flex'>
            {own.map((item, index) => (
              <div ref={(el) => {
                // 将 DOM 节点存储到 Map 中，以便后续查找
                if (el) {
                  itemRefs.current.set(item.maiyou_gameid, el);
                } else {
                  itemRefs.current.delete(item.maiyou_gameid);
                }
              }} key={index} className={`discussion-item ` + (activeItem?.maiyou_gameid == item.maiyou_gameid ? 'active' : '')} onClick={() => {
                props.handleIsOwn(true)
                props.handleActiveIndex(index)
              }}>
                {activeItem?.maiyou_gameid == item.maiyou_gameid && <img src="resources/251009/item-select.png" alt="" />}
                <img className='icon' src={item.icon} alt="" />
              </div>
            ))}
          </div>
          {own.length > 0 && <div className='community-header-separator'></div>}
          <div className='hot-discussion flex'>
            {hot.map((item, index) => (
              <div ref={(el) => {
                // 将 DOM 节点存储到 Map 中，以便后续查找
                if (el) {
                  itemRefs.current.set(item.maiyou_gameid, el);
                } else {
                  itemRefs.current.delete(item.maiyou_gameid);
                }
              }} key={index} className={`discussion-item ` + (activeItem?.maiyou_gameid == item.maiyou_gameid ? 'active' : '')} onClick={() => {
                props.handleActiveIndex(index)
                props.handleIsOwn(false)
                handleHotGameClick(item, index)
              }}>
                {activeItem?.maiyou_gameid == item.maiyou_gameid && <img src="resources/251009/item-select.png" alt="" />}
                <img className='icon' src={item.icon} alt="" />
              </div>
            ))}
          </div>
        </div>
        <NavLink className="community-header-more" onClick={() => setVisible(true)}>
          <img src="resources/251009/more.png" alt="" height={36} />
        </NavLink>
      </div>}

      {isMainCommunity && <div className='community-item-header-info flex' style={{ opacity: scrollTop > 150 ? 1 : 0, zIndex: scrollTop > 150 ? 5 : 1 }}>
        <img className='icon' src={activeItem?.bgicon} alt="" />
        <div className='name'>{activeItem?.game_name}</div>
        <div className='im'>{imDiv('chat')}</div>
      </div>}

      {activeItem?.maiyou_gameid && <div className={`${prefix}` + `community-item-content `} style={{
        backgroundColor: scrollTop > 180 ? 'white' : 'transparent',
        top: isMainCommunity ? 'calc(env(safe-area-inset-top) + 120px)' : 'calc(env(safe-area-inset-top) + 40px)',
      }}>

        <div className={'game-info ' + (isMainCommunity ? 'main' : '')}>
          {!isMainCommunity && <img className='game-logo' src={activeItem?.bgicon} alt="" />}

          <div className="game-content">
            <div className='game-name'>{activeItem?.game_name}</div>
            <div className='game-desc'>{activeItem?.description}</div>
            <div className='game-pro'>{activeItem?.heat_speech_text}</div>
          </div>

          {isMainCommunity && <div>{imDiv('game-chat')}</div>}

          {!isMainCommunity && activeItem?.is_open_cluster && <NavLink to={'/game?id=' + activeItem?.game_id} user={false} className="chat-info">
            <div className='btn'>下载游戏</div>
            <img className='right' src="resources/251009/right.png" alt="" />
          </NavLink>}
        </div>

        <div ref={scrollRef} style={{ top: isMainCommunity ? 'calc(env(safe-area-inset-top) + 180px)' : 'calc(env(safe-area-inset-top) + 110px)' }} className='community-item-content-buttons'>
          <Swiper className='community_swiper_index' onSlideChange={swiper => setCurrent(swiper.activeIndex)}>
            {actions.map((item, index) => (
              <SwiperSlide className='community_swiper_slide_index' key={index}>
                <div style={{ display: 'flex', width: '100%' }}>
                  {item.map(action => {
                    return actionsDivs(action, 'action')
                  })}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {actions.length > 1 && <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: 10 }}>
          <PageIndicator
            style={{ '--dot-spacing': '5px', '--dot-color': '#EEE', '--active-dot-color': 'var(--MainColor)', '--active-dot-size': '10px', '--active-dot-border-radius': '2px', '--dot-border-radius': '2px', '--dot-size': '4px' }}
            total={actions.length}
            current={current}
          />
        </div>}

        {activity_list.length > 0 && <div className='community-item-activity' style={{ paddingBottom: activity_list.length > 3 ? 5 : 15 }} >
          {activitys.map((item) => (
            actionsDivs(item, 'activity')
          ))}

          {activity_list.length > 3 && close && <div className='activity-more' onClick={() => { setActivitys(activity_list); setClose(false) }}>
            <img className='icon' src="resources/251009/down.png" alt="" />
          </div>}

          <div style={{ display: 'flex', alignItems: 'center', backgroundColor: 'white' }}>
            <img className='community-item-activity-line' src="resources/251009/line.png" alt="" />
          </div>

        </div>}

        <div className={`${prefix}community-item-tabs`} style={{
          borderTopLeftRadius: activity_list.length > 0 ? '0' : '8px',
          borderTopRightRadius: activity_list.length > 0 ? '0' : '8px'
        }}>
          {activeItem?.circles_type == 'game' ? <div className="tab">
            {router.map((item, index) => {
              return (
                <div key={item.id} className={'item ' + (index === idx ? 'active' : '')} onClick={() => setIdx(index)}>
                  <img style={{ paddingRight: '4px' }} src={item.src} alt="" height={16} />
                  <span>{item.name}</span>
                </div>
              )
            })}
          </div> :
            <div className='tab'>
              <div className='item active'>
                <span>全部帖子</span>
              </div>
            </div>
          }
          <Popover.Menu
            getContainer={document.getElementById('root')}
            className='community-sorts'
            actions={sorts}
            mode={'dark'}
            placement='bottom-start'
            onAction={node => {
              setSort(node)
            }}
            trigger='click'>
            <div className="sort">
              <span className='text'>{sort.text}</span>
              <img className='icon' src="resources/community/sort.png" alt="" />
            </div>
          </Popover.Menu>

        </div>

        {activeItem && <div className={`${prefix}community-item-list `}>
          {router.map((item, index) => {
            return (
              <div key={index} className={'item ' + (index === idx ? 'active' : 'none')}>
                <item.component
                  init={handleInit}
                  active={index === idx && active === true}
                  topic_id={activeItem?.maiyou_gameid}
                  tagid={item.tagid}
                  circles_type={activeItem?.circles_type}
                  tagidActiveIndex={idx}
                  sort={sort.key}
                  search={search_info}
                  community={true}
                  isMainCommunity={isMainCommunity}
                >
                </item.component>
              </div>
            )
          })}
        </div>}
      </div>}

      <CommunityGames visible={visible} onClose={() => setVisible(false)} />

      {activeItem?.is_publish && <NavLink onClick={() => {

        if (user.isCheckAuth && !user.isRealNameAuth) {
          setIsCheckAuth(true)
          return
        }

        if (activeItem?.circles_type == 'game') {
          setAlert(true)
        } else {
          setCachePublish_from_game(activeItem);
          general.history.push('/publish?tagid=0&topic_id=' + activeItem?.maiyou_gameid + '&is_display_activetab=' + activeItem?.is_display_activetab)
        }
      }} className='community-page-publish'>
        <img src="resources/community/publish.png" alt="" height={44} />
        <img style={{ position: 'absolute', top: '-6px', right: '-3px' }} height={13} src="resources/250410/publish.png" alt="" />
      </NavLink>}

      {scrollTop > 100 && <div onClick={() => {
        const div = document.getElementsByClassName(`${prefix}community-item-content`)[0]
        div.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }} style={{ display: 'flex', position: 'absolute', right: 15, bottom: activeItem?.is_publish ? 85 : 20, width: 44, height: 44, zIndex: 20 }}>
        <img src="resources/251009/community_top.png" alt="" />
      </div>}

      <PublishAlert isMainCommunity={isMainCommunity} visible={alert} activeItem={activeItem} onClose={() => setAlert(false)} />

      <AuthAlert isCheckAuth={isCheckAuth} onClose={() => setIsCheckAuth(false)} handleAuthSuccess={info => {
        setUser({ ...user, ...info })
      }}></AuthAlert>
    </div>
  )
}
